import React from 'react';
import { 
 LockKeyhole, // For Security
 QrCode, // For Tracking
 ShieldCheck, // For Tamper-Proof
 Search, // For Traceability
 BarChart2, // For POD Records
 Package // For Delivery
} from 'lucide-react';

const ProductCategory1 = () => {
const leftFeatures = [
 {
   icon: <LockKeyhole size={40} />,
   title: "Secure Sealing",
   description: "Advanced security features with tamper-evident seals ensuring package integrity throughout transit.",
   isYellow: false
 },
 {
   icon: <QrCode size={40} />,
   title: "Smart Tracking",
   description: "Integrated QR codes and barcodes for real-time tracking and instant delivery updates.",
   isYellow: true
 },
 {
   icon: <ShieldCheck size={40} />,
   title: "Tamper-Proof",
   description: "Specially designed security features that clearly indicate any tampering attempts during transit.",
   isYellow: false
 },
];

const rightFeatures = [
 {
   icon: <Search size={40} />,
   title: "Traceability",
   description: "Complete end-to-end tracking capabilities for monitoring shipment progress and delivery status.",
   isYellow: true
 },
 {
   icon: <BarChart2 size={40} />,
   title: "POD Records",
   description: "Digital proof of delivery system ensuring documented confirmation of successful deliveries.",
   isYellow: false
 },
 {
   icon: <Package size={40} />,
   title: "Reliable Delivery",
   description: "Durable construction protecting contents during transit while maintaining tracking functionality.",
   isYellow: true
 }
];

const Feature = ({ icon, title, description, isYellow }) => (
  <div className="d-flex align-items-start mb-4 feature-item">
    <div className={`rounded-circle p-3 ${isYellow ? 'bg-warning bg-opacity-10' : 'bg-success bg-opacity-10'}`}>
      {icon}
    </div>
    <div className="ms-3">
      <h3 className="h6 fw-bold mb-2">{title}</h3>
      <p className="small text-muted mb-0">{description}</p>
    </div>
  </div>
);

return (
  <div className="container py-5">
    <div className="row justify-content-center mb-5">
      <div className="col-12 col-lg-8 text-center">
        <h2 className="display-6 fw-bold mb-3">POD Courier Bags Premium Details</h2>
        <p className="text-muted mb-0">
        Professional POD courier bags with advanced tracking features and tamper-evident security, ensuring safe and traceable delivery of your valuable shipments.
        </p>
      </div>
    </div>

    <div className="row align-items-center gy-5">
      {/* Left Features */}
      <div className="col-12 col-md-4">
        <div className="pe-md-4">
          {leftFeatures.map((feature, index) => (
            <Feature key={index} {...feature} />
          ))}
        </div>
      </div>

      {/* Center Image */}
     <div className="col-12 col-md-4 text-center mb-4 mb-md-0">
        <div className="position-relative image-container">
          <div className="rounded-circle d-flex align-items-center justify-content-center mx-auto" 
               style={{ 
                 width: '350px',
                 height: '350px',
                 maxWidth: '100%',
                 overflow: 'hidden'
               }}>
            <img
              src="/assets/products-circle-images/pod-courier-bag-circle.png"
              alt="pod-courier-bag"
               className="img-fluid product-zoom-image"
              style={{ maxWidth: '100%', height: 'auto' }}
            />
          </div>
        </div>
      </div>

      {/* Right Features */}
      <div className="col-12 col-md-4">
        <div className="ps-md-4">
          {rightFeatures.map((feature, index) => (
            <Feature key={index} {...feature} />
          ))}
        </div>
      </div>
    </div>

    <style jsx>{`
      .feature-item {
        transition: transform 0.3s ease;
      }
      .feature-item:hover {
        transform: translateY(-5px);
      }
      
      /* Large Zoom Effect for Product Image */
      .image-container {
        cursor: pointer;
      }
      
      .product-zoom-image {
        transition: transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        transform-origin: center center;
      }
      
      .image-container:hover .product-zoom-image {
        transform: scale(1.8);
      }
      
      @media (max-width: 768px) {
        .feature-item {
          margin-bottom: 1.5rem;
        }
        .h6 {
          font-size: 1rem;
        }
        .small {
          font-size: 0.875rem;
        }
        .rounded-circle {
          padding: 0.75rem !important;
        }
        .container {
          padding-left: 15px;
          padding-right: 15px;
        }
        .pe-md-4, .ps-md-4 {
          padding: 0 15px;
        }
        .row {
          margin-left: -15px;
          margin-right: -15px;
        }
        
        /* Adjust zoom effect for mobile */
        .image-container:hover .product-zoom-image {
          transform: scale(1.5);
        }
      }
    `}</style>
  </div>
);
};

export default ProductCategory1;